import React from "react";
import Img from "./Img";

function Cursor(props) {
    return (
        <div className={`${props.setClass} cursor`}>
            <Img fileName={props.setImage} />
        </div>
    );
}

export default Cursor;
